import MobileCarousel from "../Cards/Information/MobileCarousel";
import LiquidGlass from "../Style/LiquidGlass";
import SVG from "../SVG";

export default function HeroGuide({
  title,
  h1,
  h2,
  h3,
  icon1,
  icon2,
  icon3,
  text1,
  text2,
  text3,
}) {
  function formatText(str) {
    if (!str) return null;
    const parts = str.split("||");

    return parts.map((part, index) => (
      <span key={index}>
        {part}
        {index < parts.length - 1 && <br />}
      </span>
    ));
  }

  return (
    <div className="w-full p-5 rounded-2xl flex flex-col bg-zi-bg2-light dark:bg-gradient-to-br dark:from-amber-950 dark:via-indigo-950 dark:to-cyan-950">
      <h3 className="font-medium text-lg text-zi-text-light dark:text-zi-text-dark">
        {title}
      </h3>

      <div className="pt-5">
        <MobileCarousel
          mobileFullWidth
          compactGap
          alignStart
          desktopOverflowVisible
          itemLabel="مرحله"
        >
          <div className="relative w-full mb:w-auto lg:w-full flex flex-col gap-2.5 justify-start items-center">
            <div className="absolute -left-[calc(50%-24px)] top-[24px] -translate-y-full w-[calc(100%-68px)] hidden lg:block 2xl:hidden">
              <SVG name="line" classname="" />
            </div>
            <LiquidGlass tag="div" rounded="full" className="size-10 lg:size-12 bg-zi-inputbg-dark/0 rounded-full flex justify-center items-center" >
              <SVG
                name={icon1}
                classname="stroke-white fill-white size-5 lg:size-6"
              />
            </LiquidGlass>
            <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
              {h1}
            </h4>
            <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
              {formatText(text1)}
            </p>
          </div>

          <div className="relative w-full mb:w-auto lg:w-full flex flex-col gap-2.5 justify-start items-center">
            <div className="absolute -left-[calc(50%-24px)] top-[24px] w-[calc(100%-68px)] hidden lg:block 2xl:hidden">
              <SVG name="lineMirrored" classname="" />
            </div>
            <LiquidGlass tag="div" rounded="full" className="size-10 lg:size-12 bg-zi-inputbg-dark/0 rounded-full flex justify-center items-center" >
              <SVG
                name={icon2}
                classname="stroke-white fill-white size-5 lg:size-6"
              />
            </LiquidGlass>
            <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
              {h2}
            </h4>
            <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
              {formatText(text2)}
            </p>
          </div>

          <div className="w-full mb:w-auto lg:w-full flex flex-col gap-2.5 justify-start items-center">
            <LiquidGlass tag="div" rounded="full" className="size-10 lg:size-12 bg-zi-inputbg-dark/0 rounded-full flex justify-center items-center" >
              <SVG
                name={icon3}
                classname="stroke-white size-5 lg:size-6"
              />
            </LiquidGlass>
            <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
              {h3}
            </h4>
            <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
              {formatText(text3)}
            </p>
          </div>
        </MobileCarousel>
      </div>
    </div>
  );
}
